import { Image } from '@/types/image.type';
import { Link } from '@/types/link.type';

export type ProjectCategory = 'website' | 'marine' | 'tourism' | 'ecommerce' | 'maintenance' | 'fitness';

export interface Project {
  title: string;
  description: string;
  image: Image;
  imageMobile?: Image;
  categories: ProjectCategory[];
  link?: Link;
}

export const projectCategories: ProjectCategory[] = [
  'website',
  'marine',
  'tourism',
  'ecommerce',
  'maintenance',
  'fitness',
];

export const projects: Project[] = [
  {
    title: 'projects.serwizz.title',
    description: 'projects.serwizz.shortDescription',
    image: { src: '/images/projects/serwizz.webp', alt: 'Serwizz' },
    imageMobile: { src: '/images/projects/serwizz-mobile.webp', alt: 'Serwizz' },
    categories: ['maintenance'],
    link: { href: '/work/serwizz-cmms', text: 'readMoreAbout' },
  },
  {
    title: 'projects.boat4you.title',
    description: 'projects.boat4you.shortDescription',
    image: { src: '/images/projects/boat4you.webp', alt: 'Boat4You' },
    imageMobile: { src: '/images/projects/boat4you-mobile.webp', alt: 'Boat4You' },
    categories: ['marine', 'tourism'],
    link: { href: '/work/boat4you', text: 'readMoreAbout' },
  },
  {
    title: 'projects.capax.title',
    description: 'projects.capax.shortDescription',
    image: { src: '/images/projects/capax.webp', alt: 'Capax' },
    imageMobile: { src: '/images/projects/capax-mobile.webp', alt: 'Capax' },
    categories: ['maintenance'],
    link: { href: '/work/capax-service-report-app', text: 'readMoreAbout' },
  },
  {
    title: 'projects.des.title',
    description: 'projects.des.shortDescription',
    image: { src: '/images/projects/des.webp', alt: 'DES' },
    imageMobile: { src: '/images/projects/des-mobile.webp', alt: 'DES' },
    categories: ['maintenance'],
    link: { href: '/work/des-time-tracking', text: 'readMoreAbout' },
  },
  {
    title: 'projects.proDesk.title',
    description: 'projects.proDesk.shortDescription',
    image: { src: '/images/projects/pro-desk.webp', alt: 'ProDesk' },
    imageMobile: { src: '/images/projects/pro-desk-mobile.webp', alt: 'ProDesk' },
    categories: ['fitness'],
  },
  {
    title: 'projects.europeYachts.title',
    description: 'projects.europeYachts.shortDescription',
    image: { src: '/images/projects/europe-yachts.webp', alt: 'Europe Yachts' },
    imageMobile: { src: '/images/projects/europe-yachts-mobile.webp', alt: 'Europe Yachts' },
    categories: ['marine', 'tourism', 'website'],
    link: { href: '/work/europe-yachts', text: 'readMoreAbout' },
  },
  {
    title: 'projects.sailweek.title',
    description: 'projects.sailweek.shortDescription',
    image: { src: '/images/projects/sailweek.webp', alt: 'Sailweek' },
    imageMobile: { src: '/images/projects/sailweek-mobile.webp', alt: 'Sailweek' },
    categories: ['marine', 'tourism', 'website'],
    link: { href: '/work/sailweek', text: 'readMoreAbout' },
  },
  {
    title: 'projects.cataSailing.title',
    description: 'projects.cataSailing.shortDescription',
    image: { src: '/images/projects/cata-sailing.webp', alt: 'Cata Sailing' },
    imageMobile: { src: '/images/projects/cata-sailing-mobile.webp', alt: 'Cata Sailing' },
    categories: ['marine', 'tourism', 'website'],
    link: { href: '/work/cata-sailing', text: 'readMoreAbout' },
  },
  {
    title: 'projects.catamaranCharter.title',
    description: 'projects.catamaranCharter.shortDescription',
    image: { src: '/images/projects/catamaran-charter.webp', alt: 'Catamaran Charter' },
    imageMobile: { src: '/images/projects/catamaran-charter-mobile.webp', alt: 'Catamaran Charter' },
    categories: ['marine', 'tourism', 'website'],
  },
  {
    title: 'projects.fGroup.title',
    description: 'projects.fGroup.shortDescription',
    image: { src: '/images/projects/fgroup.webp', alt: 'F Group' },
    imageMobile: { src: '/images/projects/fgroup-mobile.webp', alt: 'F Group' },
    categories: ['website'],
    link: { href: '/work/fgroup', text: 'readMoreAbout' },
  },
  {
    title: 'projects.hyperlightOptics.title',
    description: 'projects.hyperlightOptics.shortDescription',
    image: { src: '/images/projects/hyperlight-optics.webp', alt: 'Hyperlight Optics' },
    imageMobile: { src: '/images/projects/hyperlight-optics-mobile.webp', alt: 'Hyperlight Optics' },
    categories: ['website', 'ecommerce'],
    link: { href: '/work/hyperlight-optics', text: 'readMoreAbout' },
  },
  {
    title: 'projects.vitaBenedicta.title',
    description: 'projects.vitaBenedicta.shortDescription',
    image: { src: '/images/projects/vita-benedicta.webp', alt: 'Vita Benedicta' },
    imageMobile: { src: '/images/projects/vita-benedicta-mobile.webp', alt: 'Vita Benedicta' },
    categories: ['website'],
    link: { href: '/work/vita-benedicta', text: 'readMoreAbout' },
  },
  {
    title: 'projects.booker.title',
    description: 'projects.booker.shortDescription',
    image: { src: '/images/projects/booker.webp', alt: 'Booker.hr' },
    categories: ['tourism', 'website'],
  },
  {
    title: 'projects.znjan.title',
    description: 'projects.znjan.shortDescription',
    image: { src: '/images/projects/znjan.webp', alt: 'Žnjan' },
    categories: ['website'],
  },
  {
    title: 'projects.medAdapt.title',
    description: 'projects.medAdapt.shortDescription',
    image: { src: '/images/projects/medadapt.webp', alt: 'MedAdapt' },
    categories: ['website'],
  },
];
